import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import Team from './Team'
import clubStore from '../../../storage/ClubStore'
import {useParams} from "react-router";

const EditTeam = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.getTeam(args.id)
  }, [args.id]);
  return (
    <Team/>
  );
};

export default observer(EditTeam);